/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Tree_Duplicate_RowsInputs */

const en_statement_tree_duplicate_rows = /** @type {(inputs: Statement_Tree_Duplicate_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some rows repeat the same path`)
};

const nl_statement_tree_duplicate_rows = /** @type {(inputs: Statement_Tree_Duplicate_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sommige rijen hebben hetzelfde pad`)
};

/**
* | output |
* | --- |
* | "Some rows repeat the same path" |
*
* @param {Statement_Tree_Duplicate_RowsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_tree_duplicate_rows = /** @type {((inputs?: Statement_Tree_Duplicate_RowsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Tree_Duplicate_RowsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_tree_duplicate_rows(inputs)
	return en_statement_tree_duplicate_rows(inputs)
});